module.exports = __webpack_public_path__ + "4382d3f4c09f72d31d5a4ed1c461b836.png";